import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect } from "react";
import MDButton from "../../components/MDButton";
import ProductEdit from "./edits/ProductEdit";
import buildComboTable from "layouts/product/data/comboTableData";
import buildProductTable from "layouts/product/data/projectsTableData";
import ComboEdit from "./edits/ComboEdit";
import apis from "../../context/api";

function Products() {
  const [comboUpdate, setComboUpdate] = useState(false);
  const [productUpdate, setProductUpdate] = useState(false);
  const [id, setId] = useState(null);
  const [comboData, setComboData] = useState({ columns: [], rows: [] });
  const [projectData, setProjectData] = useState({ columns: [], rows: [] });
  const handleCancel = () => {
    setProductUpdate(false);
    setComboUpdate(false);
  };
  const productUpdated = () => {
    setProductUpdate(false);
    setComboUpdate(false);
    loadTableData();
  };
  const comboUpdated = () => {
    setProductUpdate(false);
    setComboUpdate(false);
    loadTableData();
  };
  useEffect(() => {
    loadTableData();
  }, []);
  const editProduct = (id) => {
    setId(id);
    setProductUpdate(true);
  };
  const editCombo = (id) => {
    setId(id);
    setComboUpdate(true);
  };

  const loadTableData = async () => {
    try {
      apis
        .getCombos()
        .then((comboData) => {
          setComboData(buildComboTable(comboData, (id) => editCombo(id)));
        })
        .catch((err) => {
          throw new Error("Can not get Combos");
        });

      apis
        .getProducts()
        .then((productData) => {
          setProjectData(buildProductTable(productData, (id) => editProduct(id)));
        })
        .catch((err) => {
          throw new Error("Can not get Products");
        });
    } catch (err) {
      console.error("Data loading error:", err);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {productUpdate && <ProductEdit onSuccess={productUpdated} id={id} onCancel={handleCancel} />}
      {comboUpdate && <ComboEdit onSuccess={comboUpdated} id={id} onCancel={handleCancel} />}
      {!productUpdate && !comboUpdate && (
        <MDBox pt={6} pb={6}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Combo Table
                  </MDTypography>
                </MDBox>
                <Grid container justifyContent="flex-end" pr={2} pt={2}>
                  <Grid item>
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        setId(null);
                        setComboUpdate(true);
                      }}
                    >
                      Create
                    </MDButton>
                  </Grid>
                </Grid>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: comboData.columns, rows: comboData.rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Product Table
                  </MDTypography>
                </MDBox>
                <Grid container justifyContent="flex-end" pr={2} pt={2}>
                  <Grid item>
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        setId(null);
                        setProductUpdate(true);
                      }}
                    >
                      Create
                    </MDButton>
                  </Grid>
                </Grid>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns: projectData.columns, rows: projectData.rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Products;
